import { defineStore } from "pinia";

export const useDynamicComponentEntityStore = defineStore("dynamic-component-entity-store", {
  state: () => ({
    entities: {},
    loadingStates: {},
  }),
  actions: {
    markEntityAsLoading(entityType, entityId) {
      if (!this.loadingStates[entityType]) {
        this.loadingStates[entityType] = {};
      }
      this.loadingStates[entityType][entityId] = true;
    },
    getEntityLoadingState(entityType, entityId) {
      if (!this.loadingStates[entityType]) {
        return false;
      }
      return this.loadingStates[entityType][entityId] || false;
    },
    markEntityAsNotLoading(entityType, entityId) {
      if (!this.loadingStates[entityType]) {
        this.loadingStates[entityType] = {};
      }
      this.loadingStates[entityType][entityId] = false;
    },
    addEntityToStore(entityType, entityId, entity) {
      if (!this.entities[entityType]) {
        this.entities[entityType] = {};
      }
      this.entities[entityType][entityId] = entity;
    },
  },
});
